var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "card__container",
      on: {
        mousedown: _vm.markStartCursor,
        mouseup: function($event) {
          return _vm.redirectToSlug(_vm.info.slug, $event)
        }
      }
    },
    [
      _vm.badge.text
        ? [
            _c(
              "div",
              {
                staticClass: "card__badge",
                style: _vm.setBadgeStyle(_vm.badge.bgColor, _vm.badge.textColor)
              },
              [
                _c("div", { style: _vm.innerBadgeStyle(_vm.badge.bgColor) }, [
                  _vm._v("\n        " + _vm._s(_vm.badge.text) + "\n      ")
                ])
              ]
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.info.desktopCardAsset
        ? _c("div", { staticClass: "card__image-wrapper" }, [
            _c("img", {
              staticClass: "card__image",
              attrs: {
                src: _vm.info.desktopCardAsset,
                alt: _vm.info.publicTitle,
                loading: _vm.loadImageLazily ? "lazy" : false
              }
            })
          ])
        : _c("div", {
            staticClass: "card__image-wrapper card__image-wrapper--placeholder"
          }),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "card__labels" },
        _vm._l(_vm.info.keywords, function(keyword, index) {
          return _c("li", { key: index }, [_vm._v(_vm._s(keyword))])
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "card__text" }, [
        _c("strong", { staticClass: "card__title" }, [
          _vm._v(_vm._s(_vm.info.publicTitle))
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "card__content" }, [
          _vm._v(_vm._s(_vm.info.publicDescription))
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }